<div class="c-nav-panel">
  <div class="c-nav-panel__top">
    <div class="c-nav-panel__item" (mouseenter)="openCrmSwitchModal()">
      <div class="c-nav-panel__logo">
        <img *ngIf="applications" [src]="applications[0].logo || 'assets/new-img/logo/ts-logo.svg'" />
      </div>
      <div class="c-nav-panel__subtitle">{{ applications ? applications[0].shortType : null }}</div>
    </div>
    <div class="c-nav-panel__header">
      <gtd-selector-carousel-header></gtd-selector-carousel-header>
    </div>
    <span class="c-nav-panel__separator"></span>
  </div>

  <div
    class="c-nav-panel__item c-nav-panel__item--setings"
    p500UITooltip
    i18n-tooltipData="@@common.control_product"
    tooltipData="Control Product"
    tooltipPlacement="right"
    (mouseenter)="openCrmSwitchModal()"
  >
    <a href="https://control{{ partOfLink }}/{{ globalData.current_language }}/app/company" target="_blank">
      <div class="c-nav-panel__logo">
        <img src="assets/new-img/logo/control.svg" />
      </div>
    </a>
    <div class="c-nav-panel__subtitle">Cp</div>
  </div>

  <div class="c-nav-panel__bottom">
    <div class="c-nav-panel__button d-md-none">
      <p500-ui-navbar-button
        icon="p500-ui-icon-suitcase-01"
        [class.is-active]="sidebarService.isCurrent('menu')"
        (click)="openMenuSection('menu')"
      ></p500-ui-navbar-button>
    </div>
    <div
      *ngIf="notifications"
      p500UITooltip
      i18n-tooltipData="@@common.notifications"
      tooltipData="Notifications"
      tooltipPlacement="right"
      class="c-nav-panel__button c-nav-panel__button--notifications"
      [class.is-notification]="!isAlertRead"
      [class.is-critical-incident]="isCriticalAlert"
      [class.is-danger-incident]="isDangerAlert"
      [class.is-active]="isNotificationsOpen"
      (click)="openNotificationsMenu(latestAlertDate)"
    >
      <p500-ui-icon name="bell"></p500-ui-icon>
      <!-- <gtd-notifications-menu cssClass="-box -floating"></gtd-notifications-menu> -->
    </div>
    <div class="c-nav-panel__button">
      <p500-ui-navbar-button
        icon="p500-ui-icon-question-circle"
        [class.is-active]="sidebarService.isCurrent('help')"
        (click)="openMenuSection('help')"
      >
        <gtd-help-menu *p500UINavbarButtonPopup cssClass="-box -floating"></gtd-help-menu>
      </p500-ui-navbar-button>
    </div>
    <div class="c-support-menu c-nav-panel__button" *ngIf="false && frontAppChatId">
      <!-- disabled by https://platform500.atlassian.net/browse/PP-2218 -->
      <p500-ui-navbar-button icon="p500-ui-icon-chat" [class.is-active]="sidebarService.isCurrent('support')" (click)="openSupportChat()">
      </p500-ui-navbar-button>
      <div class="c-support-menu__unread-indicator" [class.d-none]="!hasUnreadMessage"></div>
    </div>
    <a *ngIf="settingsAccess" class="c-nav-panel__button" [routerLink]="'/app/settings'" routerLinkActive="-black" (click)="closeSidebar()">
      <p500-ui-navbar-button icon="p500-ui-icon-settings"></p500-ui-navbar-button>
    </a>
    <div class="c-language-menu c-nav-panel__button">
      <p500-ui-navbar-button
        icon="p500-ui-icon-planet"
        [class.is-active]="sidebarService.isCurrent('language')"
        (click)="openMenuSection('language')"
      >
        <gtd-language-menu *p500UINavbarButtonPopup cssClass="-box -floating"></gtd-language-menu>
      </p500-ui-navbar-button>
    </div>
    <div class="c-nav-panel__button">
      <p500-ui-navbar-button
        icon="p500-ui-icon-user-fill"
        [class.is-active]="sidebarService.isCurrent('profile')"
        (click)="openMenuSection('profile')"
      >
        <gtd-profile-menu *p500UINavbarButtonPopup cssClass="-box -floating"></gtd-profile-menu>
      </p500-ui-navbar-button>
    </div>
  </div>
</div>
